/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_TitleInputs */

const en_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Successful`)
};

const fr_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication reussie`)
};

const de_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolgreich veröffentlichen`)
};

const it_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione riuscita`)
};

const ru_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовано успешно`)
};

const es_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación exitosa`)
};

const zh_cn2_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布成功`)
};

const ja_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開に成功しました`)
};

const hi_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सफल प्रकाशन`)
};

const pt_pt2_iconik_publish_success_title = /** @type {(inputs: Iconik_Publish_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicação bem-sucedida`)
};

/**
* | output |
* | --- |
* | "Publish Successful" |
*
* @param {Iconik_Publish_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_title = /** @type {((inputs?: Iconik_Publish_Success_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_success_title(inputs)
	if (locale === "de") return de_iconik_publish_success_title(inputs)
	if (locale === "it") return it_iconik_publish_success_title(inputs)
	if (locale === "ru") return ru_iconik_publish_success_title(inputs)
	if (locale === "es") return es_iconik_publish_success_title(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_success_title(inputs)
	if (locale === "ja") return ja_iconik_publish_success_title(inputs)
	if (locale === "hi") return hi_iconik_publish_success_title(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_success_title(inputs)
	return en_iconik_publish_success_title(inputs)
});